/* eslint-disable */

(function ($) {
    $.widget("ep.customScrollbar", {
        options: {
            selectors: {
                viewport: ".viewport",
                content: ".overview",
                scrollbar: ".scrollbar",
                scrolltrack: ".track",
                scrollthumb: ".track .thumb"
            },
            initialPosition: 0,
            extranalMarkup: true,
            minHeight: 20,
            wrapInner: false
        },

        _create: function () {
            var self = this;

            if (self.options.elementAsViewPort){
                self.sourceElement =
                    self.element
                        .addClass("viewport")
                        .wrapInner("<ul class=\"overview\"></ul>")
                        .wrap("<div class=\"scrollbar-wrapper\"></div>")
                        .parent()
                        .prepend('<div class="scrollbar"><div class="track"><div class="thumb"></div></div></div>');

                self.addedDomElements = [$(".scrollbar", self.element.closest(".scrollbar-wrapper"))];
                self.wrappedDomElements = [
                    $(".overview", self.element),
                    self.element.closest(".scrollbar-wrapper")
                ];

            }
            else if (self.options.extranalMarkup) {
                if (!self.options.wrapInner) {
                    self.sourceElement = self.element.addClass("overview")
                        .wrap("<div class=\"scrollbar-wrapper\"><div class=\"viewport\"></div>")
                        .parent()
                        .parent()
                        .prepend('<div class="scrollbar"><div class="track"><div class="thumb"></div></div></div>');
                } else {
                    self.sourceElement =
                        self.element
                            .addClass("custom-scroll")
                            .wrapInner("<ul class=\"overview\"></ul>")
                        .wrapInner("<div class=\"viewport\"></div>")
                        .wrapInner("<div class=\"scrollbar-wrapper\"></div>");
                    $(".scrollbar-wrapper", self.sourceElement).prepend('<div class="scrollbar"><div class="track"><div class="thumb"></div></div></div>');
                }
            }
            else {
                self.sourceElement = self.element;
            }

            self.viewport = $(self.options.selectors.viewport, self.sourceElement);
            self.content = $(self.options.selectors.content, self.sourceElement);
            self.scrollbar = $(self.options.selectors.scrollbar, self.sourceElement);
            self.scrolltrack = $(self.options.selectors.scrolltrack, self.sourceElement);
            self.scrollthumb = $(self.options.selectors.scrollthumb, self.sourceElement);

            self.viewport.scrollTop(this.options.initialPosition);

            if (this.options.initialPosition) {
                self.updateAndTrySafeCurrentPosition();
            } else {
                self._updateInternal();
            }

            self._initEvents();
        },

        _init: function () {
        },

        getYPosition: function () {
            return (-1) * parseInt(this.content.position().top);
        },

        _initEvents: function () {
            var self = this;

            self.sourceElement.on("mousedown.epcustomscrollbar", self.options.selectors.scrollthumb, $.proxy(self.startdrag, self));
            self.sourceElement.on("mousedown.epcustomscrollbar", self.options.selectors.scrolltrack, $.proxy(self.scrollTo, self));
            self._initKeyboardControl();
            self._initMouseWheel();
        },

        _initMouseWheel: function () {
            this.sourceElement.on("mousewheel.epcustomscrollbar", $.proxy(this.scroll, this));
        },
        _initKeyboardControl: function () {
            this.viewport.on("scroll.epcustomscrollbar", $.proxy(this.scrollUsingKeyboard, this));
        },
        _stopKeyboardControl: function() {
            this.viewport.off("scroll.epcustomscrollbar");
        },
        _stopMouseWheel: function () {
            this.sourceElement.off("mousewheel.epcustomscrollbar");
        },


        updateAndTrySafeCurrentPosition: function(){
            var position = this.getYPosition();

            this.updateAndSetPosition(position);
        },

        updateAndSetPosition: function (position) {
            clearTimeout(this._updateTimeout);

            this._updateInternal(position, true);
        },

        update: function (position) {
            clearTimeout(this._updateTimeout);
            var self = this;
            this._updateTimeout = setTimeout(function () {
                self._updateInternal(position);
            }, 0);
        },
        
        _setPosition: function(position) {
            if (position) {
                this.top = position;
                if (this.top > this.max.bottom) {
                    this.top = this.max.bottom;
                    position = this.top;
                } else if (this.top < this.max.top) {
                    this.top = this.max.top;
                    position = this.top;
                }
            }

            this.scrollthumb.css("top", this.top * this.ratio + "px");
            this.viewport.scrollTop(position);
            this.content.trigger('customScroll');

            return position;
        },

        _updateInternal: function (position, updateandrecalc) {
            var self = this;

            if (!updateandrecalc && position) {
                this._setPosition(position);
                return;
            }

            self.top = 0;

            var viewportHeight = self.viewportHeight = self.viewport.height();
            var contentHeight = self.contentHeight = self.content.height();

            if (viewportHeight < contentHeight) {
                if (self.scrollbar.is(".disable")) {
                    self._initKeyboardControl();
                    self._initMouseWheel();
                }
                self.scrollbar.removeClass("disable");
                var trackHeight = self.scrollbar.height();
                var adoptThumbSize = Math.max(trackHeight / contentHeight * trackHeight, self.options.minHeight);
                self.ratio = (trackHeight - adoptThumbSize) / (contentHeight - viewportHeight);

                self.max = { top: 0, bottom: contentHeight - viewportHeight };
                self.scrollthumb.height(adoptThumbSize + "px");

                this._setPosition(position);

                self.content.trigger('showGroup');

            } else {
                self._stopMouseWheel();
                self._stopKeyboardControl();
                self.scrollbar.addClass("disable");
                self.top = 0;
                self.max = { top: 0, bottom: 0 };
                self.scrollthumb.css("top", 0 + "px");
                self.content.css("top", 0 + "px");
                self.viewport.scrollTop(0);
                self.content.trigger('customScroll');
                self.content.trigger('hideGroup');
            }
        },

        startdrag: function (event) {
            event.preventDefault();
            event.stopPropagation();

            var self = this;

            self.sourceElement.addClass("ondrag");

            self.dragStartPosition = event.pageY - self.scrollthumb.position().top;

            $(document).on("mousemove.epcustomscrollbar", $.proxy(self.drag, self));
            $(document).on("mouseup.epcustomscrollbar", $.proxy(self.enddrag, self));
        },

        enddrag: function () {
            this.sourceElement.removeClass("ondrag");
            this.scrollthumb.off(".epcustomscrollbar");
            $(document).off(".epcustomscrollbar");
        },

        drag: function (event) {
            event.preventDefault();
            event.stopPropagation();

            var self = this;

            var position = (event.pageY - self.dragStartPosition);
            position = position * (1 / self.ratio);

            if (position < self.max.top) {
                position = self.max.top;
            } else if (position > self.max.bottom) {
                position = self.max.bottom;
            }

            self.top = position;
            self.viewport.scrollTop(position);
        },

        scroll: function (event) {
            event.preventDefault();
            event.stopPropagation();

            var self = this;
            var position = ep.mouseWheelHelper.getScrollDeltaY(event);

            position += self.viewport.scrollTop();

            position = position < self.max.top ? self.max.top : (position > self.max.bottom ? self.max.bottom : position);

            self.viewport.scrollTop(position);
        },

        scrollTo: function (event) {
            event.preventDefault();
            event.stopPropagation();

            var self = this;

            var mouseY = event.pageY;
            var scrolltrackTop = self.scrolltrack.offset().top;
            var scrollthumbTop = self.scrollthumb.offset().top;
            var scrollthumbHeight = self.scrollthumb.height();
            var direction = mouseY > (scrollthumbTop + scrollthumbHeight) ? scrollthumbHeight : 0;

            var position = (mouseY - scrolltrackTop - direction) * (1 / self.ratio);

            self.viewport.scrollTop(position);
        },

        scrollUsingKeyboard: function (event) {

            var self = this;
            if (!self.max) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            var position = self.viewport.scrollTop();

            if (self.top == position)
                return;

            self.update(position);
        },

        destroyWithDomClean: function () {
            this.destroy();

            if(this.wrappedDomElements){
                this.wrappedDomElements.forEach(x => x.contents().unwrap());
            }
            if(this.addedDomElements){
                this.addedDomElements.forEach(x => x.remove());
            }
        },

        destroy: function () {
            this.sourceElement.off(".epcustomscrollbar");
            this._stopKeyboardControl();
            this.scrollbar.addClass("disable");
            $.Widget.prototype.destroy.call(this);
        }
    });
})(jQuery);

/* eslint-enable */